<template>
  <div v-if="enable" class="checkout-gift-packaging-container">
    <div class="checkout-form-header">
      <input
        type="checkbox"
        class="checkbox_input"
        id="gift_packaging"
        name="gift_packaging"
        :checked="giftPackaging"
        v-model="giftPackaging"
      >
      <label for="gift_packaging" class="checkout-form-title checkbox_label">
        {{ t('preview.order.gift.packaging.title') }}
        <small v-if="cost > 0">
          (<strong>+ {{ (cost * getSelectedCurrency.rate).toFixed(2) }} {{ getSelectedCurrency.code }}</strong>)
        </small>
      </label>
    </div>
    <div v-if="giftPackaging" class="form-group customerGiftPackagingInput">
      <input
        type="checkbox"
        class="checkbox_input"
        id="greetingCardInclude"
        name="greetingCardInclude"
        v-model="greetingCardInclude"
      >
      <label for="greetingCardInclude" class="checkbox_label greeting-card-include-text">{{ t('preview.order.gift.packaging.greeting.card.include') }}.</label>
    </div>
    <div v-if="giftPackaging && greetingCardInclude" class="form-group customerGreetingCardMessageInput">
      <label for="gift_packaging_message" class="gift-packaging-card-message">{{ t('preview.order.gift.packaging.greeting.card.message') }}:</label>
      <textarea
        class="form-control"
        name="gift_packaging_message"
        id="gift_packaging_message"
        v-model="giftPackagingMessage"
      ></textarea>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CheckoutGiftPackaging',
  data () {
    return {
      greetingCardInclude: false
    }
  },
  watch: {
    giftPackaging (value) {
      if (!value) {
        this.greetingCardInclude = false
        this.giftPackagingMessage = ''
      }
    },
    greetingCardInclude (value) {
      if (!value) {
        this.giftPackagingMessage = ''
      }
    }
  },
  computed: {
    ...mapGetters(['config', 'getGiftPackaging', 'getGiftPackagingMessage', 'getSelectedCurrency']),
    enable () {
      return this.config?.giftPackaging?.enable
    },
    cost () {
      return this.config?.giftPackaging?.cost
    },
    giftPackaging: {
      get () {
        return this.getGiftPackaging
      },
      set (value) {
        this.setGiftPackaging(value)
      }
    },
    giftPackagingMessage: {
      get () {
        return this.getGiftPackagingMessage
      },
      set (value) {
        this.setGiftPackagingMessage(value)
      }
    }
  },
  methods: {
    ...mapActions(['setGiftPackaging', 'setGiftPackagingMessage'])
  }
}
</script>

<style scoped>
.checkout-gift-packaging-container {
  padding: 0;
  display: grid;
  gap: 20px;
  border-bottom: unset;
}
.checkbox_input:checked + .checkbox_label {
  color: #231F20;
}
.checkbox_input {
  top: auto;
  width: 25px;
  height: 25px;
  @media screen and (max-width:1199px) {
    width: 15px;
    height: 15px;
  }
  @media screen and (max-width:767px) {
    width: 20px;
    height: 20px;
  }
}
.checkbox_label {
  position: relative;
  margin: 0;
  line-height: 2;
  padding: 0;
  color: #231F20;
  font-weight: 400;
  font-size: 17px;
  &:before {
    width: 25px;
    height: 25px;
    border: 1px solid #231F20;
    border-radius: unset;
    right: 0;
    left: auto;
    @media screen and (max-width:1199px) {
      width: 15px;
      height: 15px;
    }
    @media screen and (max-width:767px) {
      width: 20px;
      height: 20px;
    }
  }
  &:after {
    width: 6px;
    top: 8px;
    right: 9px;
    left: unset;
  }
  a {
    color: #231F20;
    font-weight: 700;
    text-decoration: underline;
  }
}
.customerGiftPackagingInput {
  margin-bottom: 0;
}
.gift-packaging-card-message {
  color: #231F20;
  font-size: 12px;
  font-weight: 700;
}
.greeting-card-include-text {
  font-size: 12px;
}
#gift-packaging-message {
  border-radius: unset;
  border: 1px solid #231F20;
  height: 80px;
  color: #231F20;
  padding: 10px 25px;
  font-weight: 400;
  font-size: 13px;
  resize:none
}
</style>
